globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.GoogleMyBusiness = appCustomerSpace.Controllers.GoogleMyBusiness || {};

appCustomerSpace.Controllers.GoogleMyBusiness.MainController = (function(superClass) {

    utils.extend(MainController, superClass);

    function MainController() {
        return MainController.__super__.constructor.apply(this, arguments);
    }

    $.extend(MainController.prototype, {
        init: function(){
            $('form.location-informations-form').each(function() {
                appCustomerSpace.Modules.GoogleMyBusiness.PhoneError.display($(this));
            });

            return MainController.__super__.init.apply(this, arguments);
        }
    });

    return MainController;

})(appCustomerSpace.Controllers.MainController);
